<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-cart" icon-small title="پلن های خریداری شده" color="accent" :loading="loading">
			<template v-slot:beforeBody>
				<div class="text-left mb-4 px-4">
					<v-btn color="primary" small dark class="mx-1" @click="buy">
						<v-icon dark>
							mdi-cart
						</v-icon>
						خرید پلن جدید
					</v-btn>
				</div>
			</template>
			<div class="px-5">
				<v-data-table :headers="headers" :items="plans" :items-per-page="500" class="elevation-1">
					<template v-slot:item.amount="{ item }">
						<span>{{ item.amount.toString().toPriceFormat() }}</span>
					</template>
				</v-data-table>
			</div>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'PurchasedPlansView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				plans: [],
				loading: false,
				headers: [
					{
						text: 'نام پلن',
						align: 'start',
						sortable: true,
						value: 'planType',
					}, {
						text: 'مبلغ',
						align: 'center',
						sortable: true,
						value: 'amount',
					}, {
						text: 'تاریخ شروع',
						align: 'center',
						sortable: true,
						value: 'startDate_Persian.date',
					}, {
						text: 'تاریخ پایان',
						align: 'center',
						sortable: true,
						value: 'endDate_Persian.date',
					}, {
						text: 'حداکثر تعداد پرونده',
						align: 'center',
						sortable: true,
						value: 'maxLoanCount',
					}, {
						text: 'تعداد باقیمانده',
						align: 'center',
						sortable: true,
						value: 'remainLoanCount',
					},
					{
						text: '',
						align: 'center',
						sortable: false,
						width: 10,
					},
				],
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/CustomerPurchasePlan/list/', null)
					.then(response => {
						this.plans = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			buy() {
				this.$router.push('/admin/buy')
			}
		},
	}
</script>
<style>
</style>
